<ngx-loading-bar></ngx-loading-bar>
<app-header-one></app-header-one>
<router-outlet></router-outlet>
<app-tap-to-top></app-tap-to-top>
<app-newsletter></app-newsletter>


<app-footer-one></app-footer-one>
